import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Button, InfoBox, Modal } from 'src/components';
import { ReactComponent as Logo } from 'src/assets/logo.svg';
import { ActionButton } from '../../styles';
import { useUserActions, useUserState } from 'src/contexts/UserContext';
import { usePreviousValue } from 'src/hooks';
import { SubscriptionProduct } from 'src/models/SubscriptionProduct';


export const BrandLogo = styled.div.attrs(({
  children: <Logo />,
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  & svg {
    width: 56px;
    height: 56px;
    align-self: center;
    display: block;
  }
`;

type CancelMessages = {
  trial?: (subscription: SubscriptionProduct) => React.ReactElement;
  content: (subscription: SubscriptionProduct) => React.ReactElement;
  second?: (subscription: SubscriptionProduct) => React.ReactElement;
  showStopChurn?: boolean;
}

// const generalFirst = () => (
//   <Box sx={{ textAlign: 'center' }}>
//     <Typography variant="subtitle1" component="div">Zanim anulujesz, upewnij się, że znasz konsekwencje:</Typography>
//     <Card variant="outlined">
//       <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         <div>❌ Ten plan nie jest już dostępny w stałej ofercie. Anulowanie uniemożliwi powrót do Twojej obecnej, niższej ceny preferencyjnej.</div>
//         <div>❌ Po zakończeniu okresu rozliczeniowego stracisz dostęp do materiałów na platformie oraz cały swój postęp.</div>
//         <div>🗓 Twój dostęp pozostanie aktywny do końca opłaconego okresu.</div>
//       </CardContent>
//     </Card>
//     <Typography variant="subtitle1" component="div" sx={{ mt: 2 }}>Czy nadal chcesz anulować subskrypcję?</Typography>
//   </Box>
// );

// const generalSecond = () => (
//   <Box sx={{ textAlign: 'center' }}>
//     <BrandLogo />
//     <Typography variant="h6" component="div">A może krótszy plan? 🥰</Typography>
//     <Typography variant="h6" component="div">Mamy dla Ciebie specjalną zniżkę na plan 3-miesięczny</Typography>
//     <Typography variant="h6" component="div">pierwsze 3 miesiące w cenie 99 zł!</Typography>
//     <Card variant="outlined">
//       <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         <div>🎟 kod <strong>PRZECHODZE99</strong> wpisz w polu Zrealizuj voucher/kod rabatowy</div>
//         <div>↖️ wybierz subskrypcję 3-miesięczną (musi widnieć przy niej cena 99zł, dopiero wtedy zatwierdź zmiany)</div>
//         <div>🗓  po zakończeniu obecnego okresu rozliczeniowego subskrypcja zostanie zmieniona na plan 3-miesięczny, a pierwsza opłata za nią zostanie pobrana ze zniżką</div>
//       </CardContent>
//     </Card>
//   </Box>
// );

const plan89First = () => (
  <Box sx={{ textAlign: 'center' }}>
    <Typography variant="subtitle1" component="div">Zanim anulujesz, upewnij się, że znasz konsekwencje:</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>❌ Po zakończeniu okresu rozliczeniowego stracisz dostęp do materiałów na platformie oraz cały swój postęp.</div>
        <div>❌ Tracisz dostęp do nowości i premier, które regularnie dodajemy!</div>
        <div>❌ Również zniżki i benefity od naszych partnerów nie będą już dla Ciebie dostępne.</div>
        <div>🗓 Twoja subskrypcja pozostanie aktywna do końca opłaconego okresu.</div>
      </CardContent>
    </Card>
    <Typography variant="subtitle1" component="div" sx={{ mt: 2 }}>Czy nadal chcesz anulować subskrypcję?</Typography>
  </Box>
);

const plan89Second = () => (
  <Box sx={{ textAlign: 'center' }}>
    <BrandLogo />
    <Typography variant="h6" component="div">A może zostaniesz z nami jeszcze trochę 🥰</Typography>
    <Typography variant="h6" component="span" className="mark-orange">Mamy dla Ciebie wyjątkową ofertę</Typography>
    <Typography variant="h6" component="div">50% zniżki na kolejny miesiąc</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>🎟 Wpisz kod <strong>ALESUPER89</strong> w polu Zrealizuj voucher/kod rabatowy</div>
        <div>↖️ Aktywowana zniżka naliczy się automatycznie przy kolejnej płatności.</div>
        <div>🥳 Utrzymujesz dostęp do benefitów, nowości i premier, które regularnie dodajemy!</div>
      </CardContent>
    </Card>
  </Box>
);

const b2bFirst = () => (
  <Box sx={{ textAlign: 'center' }}>
    <Typography variant="subtitle1" component="div">Zanim anulujesz, upewnij się, że znasz konsekwencje:</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>Twój plan subskrypcyjny <Typography component="span" color="error">nie jest dostępny w naszej stałej ofercie</Typography>. Aktualna cena miesięcznego abonamentu to 89 zł.</div>
        <div>❌ Anulowanie uniemożliwi powrót do Twojej obecnej, niższej ceny preferencyjnej.</div>
        <div>❌ Po zakończeniu okresu rozliczeniowego stracisz dostęp do materiałów na platformie oraz cały swój postęp.</div>
        <div>❌ Tracisz dostęp do nowości i premier, które regularnie dodajemy!</div>
        <div>🗓 Twoja subskrypcja pozostanie aktywna do końca opłaconego okresu.</div>
      </CardContent>
    </Card>
    <Typography variant="subtitle1" component="div" sx={{ mt: 2 }}>Czy nadal chcesz anulować subskrypcję?</Typography>
  </Box>
);


const nonActiveFirst = () => (
  <Box sx={{ textAlign: 'center' }}>
    <Typography variant="subtitle1" component="div">Zanim anulujesz, upewnij się, że znasz konsekwencje:</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>❌ Twój plan subskrypcyjny <Typography component="span" color="error">nie jest dostępny w naszej stałej ofercie</Typography>. Anulowanie uniemożliwi powrót do Twojej obecnej, niższej ceny preferencyjnej.</div>
        <div>❌ Po zakończeniu okresu rozliczeniowego stracisz dostęp do materiałów na platformie oraz cały swój postęp!</div>
        <div>❌ Tracisz dostęp do nowości i premier, które regularnie dodajemy, a także do zniżek i benefitów od naszych partnerów.</div>
        <div>🗓 Twoja subskrypcja pozostanie aktywna do końca opłaconego okresu.</div>
      </CardContent>
    </Card>
    <Typography variant="subtitle1" component="div" sx={{ mt: 2 }}>Czy nadal chcesz anulować subskrypcję?</Typography>
  </Box>
);

const plan69Second = () => (
  <Box sx={{ textAlign: 'center' }}>
    <BrandLogo />
    <Typography variant="h6" component="div">A może zostaniesz z nami jeszcze trochę 🥰</Typography>
    <Typography variant="h6" component="span" className="mark-orange">Mamy dla Ciebie wyjątkową ofertę</Typography>
    <Typography variant="h6" component="div">50% zniżki na kolejny miesiąc</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>🎟 kod <strong>ALESUPER</strong> wpisz w polu Zrealizuj voucher/kod rabatowy</div>
        <div>↖️ Aktywowana zniżka naliczy się automatycznie przy kolejnej płatności.</div>
        <div>🥳 Utrzymujesz dostęp do nowości i premier, które regularnie dodajemy!</div>
      </CardContent>
    </Card>
  </Box>
);

const oneMonthSecond = () => (
  <Box sx={{ textAlign: 'center' }}>
    <BrandLogo />
    <Typography variant="h6" component="div">A może zostaniesz z nami jeszcze trochę 🥰</Typography>
    <Typography variant="h6" component="span" className="mark-orange">Mamy dla Ciebie wyjątkową ofertę</Typography>
    <Typography variant="h6" component="div">30% zniżki na kolejny miesiąc</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>🎟 Wpisz kod <strong>SUPERPLAN</strong> w polu Zrealizuj voucher/kod rabatowy</div>
        <div>↖️ Aktywowana zniżka naliczy się automatycznie przy kolejnej płatności.</div>
        <div>🥳 Utrzymujesz dostęp do nowości i premier, które regularnie dodajemy!</div>
      </CardContent>
    </Card>
  </Box>
);

const b2bSecond = () => (
  <Box sx={{ textAlign: 'center' }}>
    <BrandLogo />
    <Typography variant="h6" component="div">A może zostaniesz z nami jeszcze trochę 🥰</Typography>
    <Typography variant="h6" component="span" className="mark-orange">Mamy dla Ciebie wyjątkową ofertę</Typography>
    <Typography variant="h6" component="div">30% zniżki na kolejny miesiąc</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>🎟 Wpisz kod <strong>STAY30</strong> w polu Zrealizuj voucher/kod rabatowy</div>
        <div>↖️ Aktywowana zniżka naliczy się automatycznie przy kolejnej płatności.</div>
        <div>🥳 Utrzymujesz dostęp do nowości i premier, które regularnie dodajemy!</div>
      </CardContent>
    </Card>
  </Box>
);

const twoMonthSecond = () => (
  <Box sx={{ textAlign: 'center' }}>
    <BrandLogo />
    <Typography variant="h6" component="div">A może zostaniesz z nami jeszcze trochę 🥰</Typography>
    <Typography variant="h6" component="span" className="mark-orange">Mamy dla Ciebie wyjątkową ofertę</Typography>
    <Typography variant="h6" component="div">30% zniżki na kolejne 2 miesiące</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>🎟 Wpisz kod <strong>TANIEJ30</strong> w polu Zrealizuj voucher/kod rabatowy</div>
        <div>↖️ Aktywowana zniżka naliczy się automatycznie przy kolejnej płatności.</div>
        <div>🥳 Utrzymujesz dostęp do nowości i premier, które regularnie dodajemy!</div>
      </CardContent>
    </Card>
  </Box>
);

const threeMonthSecond = () => (
  <Box sx={{ textAlign: 'center' }}>
    <BrandLogo />
    <Typography variant="h6" component="div">A może zostaniesz z nami jeszcze trochę 🥰</Typography>
    <Typography variant="h6" component="span" className="mark-orange">Mamy dla Ciebie wyjątkową ofertę</Typography>
    <Typography variant="h6" component="div">30% zniżki na kolejne 3 miesiące</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>🎟 Wpisz kod <strong>TANIEJ30</strong> w polu Zrealizuj voucher/kod rabatowy</div>
        <div>↖️ Aktywowana zniżka naliczy się automatycznie przy kolejnej płatności.</div>
        <div>🥳 Utrzymujesz dostęp do nowości i premier, które regularnie dodajemy!</div>
      </CardContent>
    </Card>
  </Box>
);

const sixMonthSecond = () => (
  <Box sx={{ textAlign: 'center' }}>
    <BrandLogo />
    <Typography variant="h6" component="div">A może zostaniesz z nami jeszcze trochę 🥰</Typography>
    <Typography variant="h6" component="span" className="mark-orange">Mamy dla Ciebie wyjątkową ofertę</Typography>
    <Typography variant="h6" component="div">30% zniżki na kolejne 6 miesiące</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>🎟 Wpisz kod <strong>TANIEJ30</strong> w polu Zrealizuj voucher/kod rabatowy</div>
        <div>↖️ Aktywowana zniżka naliczy się automatycznie przy kolejnej płatności.</div>
        <div>🥳 Utrzymujesz dostęp do nowości i premier, które regularnie dodajemy!</div>
      </CardContent>
    </Card>
  </Box>
);

const twelveMonthSecond = () => (
  <Box sx={{ textAlign: 'center' }}>
    <BrandLogo />
    <Typography variant="h6" component="div">A może zostaniesz z nami jeszcze trochę 🥰</Typography>
    <Typography variant="h6" component="span" className="mark-orange">Mamy dla Ciebie wyjątkową ofertę</Typography>
    <Typography variant="h6" component="div">30% zniżki na kolejne 12 miesiące</Typography>
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <div>🎟 Wpisz kod <strong>TANIEJ30</strong> w polu Zrealizuj voucher/kod rabatowy</div>
        <div>↖️ Aktywowana zniżka naliczy się automatycznie przy kolejnej płatności.</div>
        <div>🥳 Utrzymujesz dostęp do nowości i premier, które regularnie dodajemy!</div>
      </CardContent>
    </Card>
  </Box>
);

const notActivePlan = () => (
  <>
    <p><strong>UWAGA: Obecnie korzystasz z abonamentu, który nie jest już dostępny w naszej stałej ofercie. Anulacja subskrypcji uniemożliwi w przyszłości powrót do obecnej niższej ceny. Dopóki nie przerwiesz subskrypcji, możesz cieszyć się preferencyjną ceną.</strong></p>
    <p>Czy nadal chcesz anulować subskrypcję?</p>
    <p>Po zakończeniu obecnego okresu rozliczeniowego utracisz dostęp do materiałów na naszej platformie, a także utracisz swój postęp.</p>
  </>
);

const stopChurnOneWeek = () => {
  return () => (
    <>
      <p><strong>Nie kończmy tego tak szybko 💛</strong></p>
      <p>Mamy dla Ciebie specjalną propozycję – zamiast planu tygodniowego możesz przejść na plan miesięczny w wyjątkowej cenie <strong>29 zł</strong> za pierwszy miesiąc.</p>
      <p>Twój kod: <strong>PRZECHODZE</strong></p>
      <p>W pierwszej kolejności wpisz go w zakładce Zarządzaj subskrypcją w polu Zrealizuj voucher/kupon rabatowy, następnie wybierz plan "1-mies. subskrypcja w PortalYogi". <strong>Naliczona zniżka powinna być widoczna, dopiero wtedy zatwierdź zmianę planu.</strong> Gotowe!</p>
    </>
  );
};

const defaultMessages: CancelMessages = {
  trial: () => (
    <>
      <p>Czy na pewno chcesz anulować okres próbny swojej subskrypcji?</p>
      <p>Anulowanie spowoduje natychmiastową utratę dostępu do materiałów na naszej platformie.</p>
    </>
  ),
  content: () => (
    <>
      <p>Czy na pewno chcesz anulować swoją subskrypcję?</p>
      <p>Po zakończeniu obecnego okresu rozliczeniowego utracisz dostęp do materiałów na naszej platformie, a także utracisz swój postęp.</p>
    </>
  ),
};

const b2bPlans = [
  'ace00dba-8ac1-404a-b1cd-91adcdafc025', // Żappka - Subskrypcja Miesięczna
  '7ebdcabd-5a8b-44eb-9c3e-1df602623ce2', // Visa - Subskrypcja Miesięczna
  '29734b77-c767-4927-8c6f-e98013726aac', // Stepler - Subskrypcja Miesięczna
  'e58ef1ed-d920-43be-8fbe-3c1a38b0061c', // Mindgram - Subskrypcja Miesięczna
  'd024d8e5-1c32-4648-b396-3c4704f822a7', // Green Caffè Nero - Subskrypcja Miesięczna
  'ba530a5f-d269-4892-a0df-3a4ee4018e30', // Sovendus - Subskrypcja Miesięczna
  'b5fdb0b1-53ef-4e4f-a3a6-862fef21fa70', // Elle/Glamour - Subskrypcja Miesięczna
  '5111ba8d-49ea-45c8-802e-3cb859db0ed7', // YES - Subskrypcja Miesięczna
  '92149f5d-5127-4ec3-981e-e765ab961d2a', // polki.pl - Subskrypcja Miesięczna
  '2777a148-e32b-4f3b-bc58-dd0bc6aad180', // YogaBazar - Subskrypcja Miesięczna
  'c70c4e92-082e-4f12-be98-295ed029b3ae', // InPost - Subskrypcja Miesięczna
  'f0c28d5e-7545-44b3-a0e8-25d7d1fb83a1', // Legimi - Subskrypcja Miesięczna
  '436d20fc-0885-4267-adab-9303eec96c83', // Rukola - Subskrypcja Miesięczna
  'e8c8f068-bdc9-4f24-ae22-ca187befb263', // Fitatu - Subskrypcja Miesięczna
  '4ed245ef-e386-42fe-8290-0e5e3fa7c65a', // Poradnik Zdrowie - Subskrypcja Miesięczna
  '7cd32434-1b50-435d-a1d5-7e67ef5c402b', // WellBee - Subskrypcja Miesięczna
  '09f6d9df-3024-457e-974b-9a890b1cf53b', // Magenta Moments - Subskrypcja Miesięczna
  'ce6cfddb-63a9-47ed-8af3-225d7b53f828', // Wizaż - Subskrypcja Miesięczna
  '14de527a-ec4b-4bcb-9fae-e4e7869baa5d', // Helping Hand - Subskrypcja Miesięczna
  'f4aae8f3-e393-4de3-a32d-b07f22c0fca5', // MomaAyurveda - Subskrypcja Miesięczna
  '0b16e7e1-4ff1-4135-b023-57797fa894e7', // Mastercard Bezcenne Chwile - Subskrypcja Miesięczna
  '26e8a1e5-610c-476f-b994-390ad79e04f6', // Formeds - Subskrypcja Miesięczna
  '60b38310-ee96-4e00-90b5-963d6740bddc', // Dietly - Subskrypcja Miesięczna
  'bce66aa1-5957-4850-b669-a256e190dc30', // Tutlo - Subskrypcja Miesięczna
  '87605cf0-b78e-485d-8df5-176487cec7aa', // Urząd Statystyczny - Subskrypcja Miesięczna
  'f9214d2b-c89a-48ab-9e2a-ec8ab1a57c1b', // Żabka Delio - Subskrypcja Miesięczna
  '757d1a2f-f68d-4e4b-9a75-a7edd98c0538', // Uniperks - Subskrypcja Miesięczna
  '4e00a894-6034-4a67-83f8-6fc0e9f275d8', // BenefitPY - 1-mies. subskrypcja w PortalYogi
  'f01e84d7-825b-411a-ad6d-c49e0709f864', // Centrum Respo - Subskrypcja Miesięczna
  'b20d16f4-134a-4608-a965-46274111ec68', // Tchibo - Subskrypcja Miesięczna
  '1f2ab560-d668-45c4-a4f3-a9d789a34a7d', // Mokobelle - Subskrypcja Miesięczna
  '5dc3c487-4664-42ab-815c-9df7de9603a0', // Planet Heroes - Subskrypcja Miesięczna
  'a82972d0-520a-4aee-b85a-683a767929b4', // Magenta Moments 2 - Subskrypcja Miesięczna
  'd1d08ea6-e6cf-46a1-9698-9153b731e93b', // Payback - Subskrypcja Miesięczna
  '95d6c2b9-a327-4709-85bc-694a4939da8c', // PHI - Subskrypcja Miesięczna
  'a665539a-56d3-47ae-ae10-b7275a3694af', // Visa - Subskrypcja 1mc
  '5121b675-3b7a-4a1e-8ff0-bade689a54af', // Uniperks - Subskrypcja 1mc
  '23a903e9-b965-42f6-bcee-6535cf36faab', // Żappka - Subskrypcja 1mc
  '863f16e6-e39e-4ac9-9570-52c2bfcfcbd5', // InPost - Subskrypcja 1mc
  'f3188fcc-10ec-4101-8381-7e1b745dc7e1', // Empik Premium - Subskrypcja 1mc
  '9f70099d-1f4b-4283-8da3-0e25f9c014d7', // Katalog sklepy - Subskrypcja 1mc
  'ed05e5b9-6986-4a0f-bcf9-a0dc47d4791c', // Empik Premium - Subskrypcja Miesięczna
];

const oneMonthPlansOld = [
  '28f72003-52a2-4dd0-8de3-c5b94e37e54b', // Miesięczny Abonament dla przechodzących 
  'a4e00d50-061b-4dbc-b4c1-0085702646c0', // Subskrypcja miesięczna
  '20fbe72e-f117-431a-b67f-f372f1a5f3ee', // Subskrypcja miesięczna – 7 dni darmowe
  'f91db7f3-b89f-43d6-8123-abe588d21457', // Subskrypcja miesiączna - 3 dni darmowe
  'a473463f-626b-44a2-808a-4048f3c0835a', // Subskrypcja PortalYogi - 1 mies.
  'aa2cf724-c31c-4363-a2af-29ecb6f3522f', // 1 miesięczna subskrypcja
  'a4c9c6eb-c9ca-4d92-a221-aaf494e2a242', // PortalYogi 49 - 1-mies. subskrypcja
  'f90d32ce-aee8-4198-a4e0-b58c701b7e79', // Drzwi Otwarte PortalYogi
];

const twoMonthPlansOld = [
  'a0a511e8-e0ea-4e71-9a89-44a3fb4e46ee', // 2-mies. subskrypcja w PortalYogi
  '6c2a3461-6488-4ebd-9b25-a12044a18a6e', // Green Caffè Nero - Subskrypcja 2-miesięczna
  '926ab2c3-e8d4-4b3a-8278-bb503aff14fc', // Żabka Razem - Subskrypcja 2-miesięczna
  '98094871-e21a-4c52-9d9b-c495151691bb', // Mohito - Subskrypcja 2-miesięczna
];

const threeMonthPlansOld = [
  '402dd679-c33b-454b-9018-91b00effeee2', // Subskrypcja PortalYogi - 3 mies.
  'cf435bc4-36ad-4bd8-82cf-5832f73a5e46', // 3 miesięczna subskrypcja 
  '54a227d7-eae0-4861-8c11-ca7678235887', // Subskrypcja 3 miesięczna
  '69c3fd44-f8e4-4aa0-a51c-5f7f925b80d1', // 3-mies. subskrypcja w PortalYogi
  '5238295e-26c6-4d39-bb62-82ee59eff737', // 3-mies. subskrypcja – 7 dni darmowe
  '858ab7ba-afed-4568-abe1-8fecdb894d89', // BenefitPY - 3-mies. subskrypcja w PortalYogi
];

const sixMonthPlansOld = [
  '60dedac9-2722-4deb-9a4a-74a251299ec8', // 6-mies. subskrypcja w PortalYogi
  '6ed33793-7dd2-4287-ad90-505c559bc797', // Subskrypcja PortalYogi - 6 mies.
  '449d107d-6127-4571-923b-40b054a869f6', // Subskrypcja 6 miesięczna
];

const twelveMonthPlansOld = [
  '624fb812-49fb-4d7c-ab52-48a143bd4ab6', // Subskrypcja PortalYogi - 12 mies.
  '569c8fcc-d492-4a7d-b02f-04645b3cdbdd', // 12 miesięczna subskrypcja (roczna)
  '5987076a-cd9f-402f-9a03-bec426d1890d', // Roczny Abonament dla przechodzących 
  'fff40f24-53f0-4ef3-b375-728bf9b285f5', // Subskrypcja roczna
  '44e5f15c-30eb-45a2-ad64-faa16eea5be7', // 12-mies. subskrypcja w PortalYogi
  '6086f77e-89e5-49bf-95f9-55a3dee0de70', // BenefitPY - 12-mies. subskrypcja w PortalYogi
  'b2b8d09b-653c-489d-93f1-806336d9bc7c', // PortalYogi 399 - 12-mies. subskrypcja
];

const plans69 = [
  '8d55c490-cfa7-4704-b6fb-b61d07a76a7b', // 1-mies. subskrypcja w PortalYogi
  '2a573516-a427-4f97-aceb-ce25c1bc49c7', // 1-mies. subskrypcja – 7 dni darmowe
  'fa92582b-02da-4e2a-b253-9e522e4fa1ad', // 1-mies. subskrypcja – 3 dni darmowe
];

const oneWeekPlan = 'e76a1f90-c4c5-4b60-9cc3-244efbc81637'; // Tygodniowa subskrypcja w PortalYogi
const oneMonthPlan = '36aa500d-c23a-4ec9-8832-48a4a5ec83e5'; // 1mc subskrypcja PortalYogi
const twoMonthPlan = '3843ce9e-2be1-4261-be7a-39fc6052e4d4'; // 2mc subskrypcja PortalYogi
const threeMonthPlan = '60808df1-6d57-4d39-9438-bd06fe266015'; // 3mc subskrypcja PortalYogi
const sixMonthPlan = 'd51441c8-6f15-466a-baa0-c658e6945ce3'; // 6mc subskrypcja PortalYogi
const twelveMonthPlan = '08aba0d6-d765-4dae-a0b5-cbb8460de3db'; // 12mc subskrypcja PortalYogi

const cancelMessages: Record<string, CancelMessages> = {
  [oneWeekPlan]: { content: stopChurnOneWeek() },
  [oneMonthPlan]: { content: plan89First, second: plan89Second },
  [twoMonthPlan]: { content: plan89First, second: twoMonthSecond },
  [threeMonthPlan]: { content: plan89First, second: threeMonthSecond },
  [sixMonthPlan]: { content: plan89First, second: sixMonthSecond },
  [twelveMonthPlan]: { content: plan89First, second: twelveMonthSecond },
  ...Object.fromEntries(plans69.map(id => [ id, { content: nonActiveFirst, second: plan69Second } ])),
  ...Object.fromEntries(oneMonthPlansOld.map(id => [ id, { content: nonActiveFirst, second: oneMonthSecond } ])),
  ...Object.fromEntries(b2bPlans.map(id => [ id, { content: b2bFirst, second: b2bSecond } ])),
  ...Object.fromEntries(twoMonthPlansOld.map(id => [ id, { content: nonActiveFirst, second: twoMonthSecond } ])),
  ...Object.fromEntries(threeMonthPlansOld.map(id => [ id, { content: nonActiveFirst, second: threeMonthSecond } ])),
  ...Object.fromEntries(sixMonthPlansOld.map(id => [ id, { content: nonActiveFirst, second: sixMonthSecond } ])),
  ...Object.fromEntries(twelveMonthPlansOld.map(id => [ id, { content: nonActiveFirst, second: twelveMonthSecond } ])),
};

function useCancelContent(subscription: SubscriptionProduct | null | undefined, isTrialing: boolean): {
  content: React.ReactElement;
  second?: React.ReactElement;
  showStopChurn?: boolean;
  productNotActive?: boolean;
} {
  if (subscription == null) {
    return { content: defaultMessages.content(subscription!) };
  }
  const productNotActive = subscription.active !== true;
  const messages = cancelMessages[subscription.id];
  
  if (isTrialing) {
    return {
      content: (messages?.trial ?? defaultMessages.trial!)(subscription),
    }
  }
  if (messages != null) {
    return {
      content: messages.content(subscription),
      second: messages.second?.(subscription),
      showStopChurn: messages.showStopChurn,
    };
  }
  if (productNotActive) {
    return { content: notActivePlan(), productNotActive }
  }
  return { content: defaultMessages.content(subscription) };
}

export const CancelSubscription: React.FC = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [showPromoDialog, setShowPromoDialog] = useState(false);
  const { cancelSubscription } = useUserActions();
  const {
    cancelSubscriptionStatus: status,
    isCancellationPending,
    isTrialing,
    user,
  } = useUserState();
  // const openBarecancel = useBarecancel((user as unknown as {stripeId: string}).stripeId);
  const {
    content,
    second,
    productNotActive = false,
    showStopChurn = false,
  } = useCancelContent(user.subscription?.subscriptionProduct, isTrialing);

  const prevStatus = usePreviousValue(status);
  useEffect(() => {
    if (status === 'idle' && prevStatus === 'pending') {
      setShowDialog(false);
      setShowPromoDialog(false);
      // if (isCancellationPending) {
      //   openBarecancel();
      // }
    }
  }, [status, prevStatus, isCancellationPending]);

  const hideCancelButton = user.subscription == null || isCancellationPending || user.subscription.status === 'canceled';

  function onCancel() {
    if (second != null) {
      setShowDialog(false);
      setShowPromoDialog(true);
    } else {
      cancelSubscription();
    }
  }

  return (
    <>
      {!hideCancelButton && (
        <ActionButton onClick={() => setShowDialog(true)}>
          Anuluj subskrypcję
        </ActionButton>
      )}
      <Modal open={showDialog}>
        <Modal.Title>
          <BrandLogo />
          <Typography variant="h4" component="div" align="center">Przykro nam że odchodzisz 😢</Typography>
        </Modal.Title>
        <Modal.Content>
          {content}
          {status === 'error' && (
            <InfoBox
              mode="error"
              message="Anulowanie subskrypcji nie powiodło się."
            />
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button
            label={showStopChurn ? 'Zostaję w studio' : 'Powrót'}
            onClick={() => setShowDialog(false)}
            disabled={status === 'pending'}
          />
          <Button
            label={(productNotActive || showStopChurn) ? 'Anuluj mimo wszystko' : 'Anuluj subskrypcję'}
            onClick={onCancel}
            variant="minimal"
            disabled={status === 'pending'}
            pending={status === 'pending'}
          />
        </Modal.Actions>
      </Modal>

      <Modal open={showPromoDialog}>
        <Modal.Content>
          {second}
          {status === 'error' && (
            <InfoBox
              mode="error"
              message="Anulowanie subskrypcji nie powiodło się."
            />
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button
            label="Zostaję"
            color="secondary"
            onClick={() => setShowPromoDialog(false)}
            disabled={status === 'pending'}
          />
          <Button
            label="Anuluj mimo wszystko"
            onClick={cancelSubscription}
            variant="minimal"
            disabled={status === 'pending'}
            pending={status === 'pending'}
          />
        </Modal.Actions>
      </Modal>
    </>
  );
};
